import { Page } from 'componentregistry';
import { action } from '@cloudio-saas/statex';
import { designPath } from 'designer/atoms';
import { itemExpandedAtom } from './atoms';

export const expandParentsAction = action(
  (
    { get, set },
    {
      appUid,
      pageId,
      itemId,
      treename,
    }: { appUid: string; pageId: string; itemId: string; treename: string },
  ) => {
    const page = get(designPath({ appUid, pageId })) as Page;
    let parent = itemId;
    while (parent) {
      // TODO: may have to use a select instead of this atom
      set(itemExpandedAtom, true, {
        params: { appUid, pageId, itemId: parent, treename },
      });
      if (parent === 'root') {
        break;
      }
      parent = page[parent]?.parent;
    }
  },
);
